import { useEffect, useState } from "react";
import axios from "axios";
import ProductCard from "../ProductCard";

const HomePage = () => {
  const [products, setProducts] = useState([]);

  // Carrega os produtos da API
  useEffect(() => {
    axios.get("https://api.nwayami.com/api/produtos/")
      .then((response) => setProducts(response.data)) // Armazena os produtos no estado
      .catch((error) => console.log(error));
  }, []);

  return (
    <div className="">
      <ProductCard products={products} />
    </div>
  );
};

export default HomePage;
